import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 123px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border: 1px solid rgba(255, 255, 255, 0.25);
	background-color: #000000;
	border-radius: 20px;
`;

export { StyledContainer, StyledWrapper };
